import { reducer, initialState } from "../models/store/storeReducers";
import { applyMiddleware, createStore } from "redux";
import thunk from "redux-thunk";

export const customStore = createStore(reducer, initialState, applyMiddleware(thunk));